module.exports = __webpack_public_path__ + "img/algorithm.60a87724.png";